module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("\r\n\t\t" + _vm._s(_vm.nix) + "\r\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23267773!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TemplateEdit.vue
// module id = 430
// module chunks = 0